<script>
    import {createEventDispatcher} from 'svelte';

    import Caja from "../../UI/Caja.svelte";
    import {url} from '@sveltech/routify';

    import Boton from "../../UI/Boton.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";
    import EntradaSalida from "../../Horas/EntradaSalida.svelte";
    import Duracion from "../../UI/Duracion.svelte";
    import IconoDeTipo from "../Icono.svelte";

    export let tipo;

    const dispatch = createEventDispatcher();

    const eliminarTipo = () => dispatch('eliminar-tipo', tipo);
</script>

<style>
    :global(.tipoDeJornada .hora) {
        justify-content: flex-start;
    }

    .acciones {
        text-align: right;
    }

    .titulo {
        display: flex;
        align-items: flex-end;
    }

    .horario strong {
        font-weight: 500;
    }
</style>

<div class="tipoDeJornada">
    <Caja>
        <div slot="titulo" class="titulo">
            <IconoDeTipo {tipo} />
            <Subtitulo>{tipo.nombre}{tipo.nocturna ? ' (Nocturna)' : '' }</Subtitulo>
        </div>

        <p class="descripcion">{tipo.descripcion}</p>

        <div class="horario">
            {#if tipo.duracion || (tipo.horas && tipo.horas.length)}
                {#if tipo.horas}
                    <p>
                        {#each tipo.horas as hora}
                            <EntradaSalida {hora}/>
                        {/each}
                    </p>
                {/if}

                <p>
                    <strong>Tiempo diario:</strong>
                    <Duracion minutos={tipo.duracion}/>

                    {#if tipo.descansoObligatorio}
                        <br>
                        <strong>Descanso obligatorio:</strong>
                        <Duracion minutos="{tipo.descansoObligatorio}" />
                    {/if}

                    {#if tipo.entradaEstricta}
                        <br>Entrada estricta
                    {/if}
                </p>
            {:else}
                Día sin horario
            {/if}
        </div>

        <div slot="pie" class="acciones">
            <Boton href={$url(`/tipos-de-jornada/${tipo.id}`)} icono="edit" tipo="ok">
                Editar
            </Boton>
            {#if !tipo.protegido}
                <Boton on:click={eliminarTipo} icono="delete" tipo="peligro">Borrar</Boton>
            {/if}
        </div>
    </Caja>
</div>